import procedimento from './procedimento'
import exportacao from './exportacao'
import relatorioInconsistencia from './relatorioInconsistencia'

export default [
    {
        path: 'apac',
        component: () => import('@/components/base/RouterViewWrapper'),
        children: [
            ...procedimento,
            ...exportacao,
            ...relatorioInconsistencia,
        ]
    }
]